var productListValues = document.querySelectorAll("[data-product-list-value]");
productListValues.forEach((productListValue) => {

    productListValue.addEventListener("click", () => {
        var container = productListValue.closest("[data-quickadd-container]");
        var value = productListValue.dataset.productListValue;
        var btn = container.querySelector("[data-product-list-quickadd]");
    
        container.querySelector("[data-product-list-value].active").classList.remove("active");
        productListValue.classList.add("active");
    
        btn.dataset.productListQuickadd = value;
    })
})

var productListBtn = document.querySelectorAll("[data-product-list-quickadd]");
productListBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
        var variantId = btn.dataset.productListQuickadd;

        btn.querySelector("span").style.display = "none";
        btn.querySelector("svg").style.display = "block";

        addToCart(btn, 1, variantId);
    });
});

function addToCart(btn, qty, id) {
    let formData = {
        'items': [{
            'id': id,
            'quantity': qty
        }]
    };
    
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        return response.json();
    })
    .then(response => {
        console.log("Res: ", response);

        btn.querySelector("span").style.display = "block";
        btn.querySelector("svg").style.display = "none";

        if (response.items == undefined) {
            if (response.message = "Erreur panier")
                alert("Cet article est en rupture de stock");
            else
                alert("Une erreur est survenue");
            return true;
        }

        document.querySelectorAll("[data-header-cart-count]").forEach((cartCount) => {
            var currentCartCount = parseInt(cartCount.innerHTML);
            currentCartCount++;

            cartCount.innerHTML = currentCartCount;
        })

        window.location.href = "https://wankul.fr/cart";
    })
}